export default {
  attendScoreRule: '/honour/client/attendScoreRule'
}
